module.exports = __webpack_public_path__ + "img/icon-add.decfcf76.svg";